import {register} from '../../../JavaScript/Utils'

export const FileUpload = (el: HTMLElement) => {

  const fileInput = el.querySelector(
    'input[type="file"]'
  ) as HTMLInputElement

  // const globalMaxSize: number = 10485760 // TODO: save max size in form or global
  const globalMaxSize: number = parseInt(fileInput.dataset.maxSize)

  const form = el.closest(
    'form'
  ) as HTMLFormElement

  const fileList: HTMLElement = el.querySelector(
    '.comp-fileupload--file-list'
  ) as HTMLElement

  const fileInfosTemplate: HTMLElement = el.querySelector(
    '.comp-fileupload--file-infos-template'
  ) as HTMLElement

  const infoTextWrapper: HTMLElement = document.querySelector(
    '.size-info-text .clearfix'
  ) as HTMLElement

  let currentUploadSize: HTMLElement = document.querySelector(
    '.size-info-text .clearfix .current-upload-size'
  ) as HTMLElement

  const maxSize: number = +fileInput.dataset.maxSize

  if (!currentUploadSize && infoTextWrapper) {
    currentUploadSize = document.createElement("P")
    currentUploadSize.className = "current-upload-size"
    infoTextWrapper.prepend(currentUploadSize)
  }

  const updateMultipleFileCounter = () => {

    if (fileInput.multiple) {
      const wrapper: HTMLElement = fileInput.closest('.file-upload-multiple-fieldset') as HTMLElement
      const inputLabel: HTMLElement = el.querySelector('label') as HTMLElement
      const countMultipleInputs: NodeListOf<HTMLInputElement> = wrapper.querySelectorAll('.comp-fileupload input')

      let multipleCountSpan: HTMLElement = inputLabel.querySelector('span') as HTMLElement

      if (!multipleCountSpan) {
        multipleCountSpan = document.createElement("span") as HTMLElement
        inputLabel.append(multipleCountSpan)
      }

      let count: number = 0

      Array.from(countMultipleInputs).forEach((input) => {
        count += input.files.length > 0 ? 1 : 0
      })

      multipleCountSpan.innerText = ` (${count}/${countMultipleInputs.length})`
    }
  }

  updateMultipleFileCounter()

  const inputAddFile = (input: HTMLInputElement, file: File) => {
    const dt = new DataTransfer()
    dt.items.add(file)
    input.files = dt.files
  }

  const humanReadableSize = (bytes: number) => {
    // return (bytes / (1024 ** 2)).toFixed(2) + "MB"

    if (bytes === 0) {
      return "0.00 B"
    }

    const e = Math.floor(Math.log(bytes) / Math.log(1024))
    return (bytes / Math.pow(1024, e)).toFixed(2) + ' ' + ' KMGTP'.charAt(e) + 'B'
  }

  const disableSend = (bool: boolean) => {
    const submit = form.querySelector('button[type="submit"]') as HTMLButtonElement
    submit.disabled = bool
  }

  const checkUploadSize = () => {
    const inputs = form.querySelectorAll(
      'input[type="file"]'
    ) as NodeListOf<HTMLInputElement>

    let uploadSize = 0

    inputs.forEach((input) => {

      const currentEl = input.closest(".comp-fileupload")
      currentEl.classList.remove("show-error")

      Array.from(input.files).forEach((file) => {
        uploadSize += file.size
        if (file.size > maxSize) {
          currentEl.classList.add("show-error")
        }
      })
    })

    const uploadToLarge = uploadSize > globalMaxSize
    disableSend(uploadToLarge)
    form.classList.toggle("error", uploadToLarge)
    form.classList.toggle("upload-error", uploadToLarge)
    form.classList.toggle('show-upload-size', uploadSize > 0)

    if (currentUploadSize) currentUploadSize.innerHTML = `<span class="${(uploadToLarge ? 'color-error-red' : '')}">${humanReadableSize(uploadSize)}</span> / <span>${humanReadableSize(globalMaxSize)}</span>`

  }

  const addFilenameWithButton = (input: HTMLInputElement, file: File) => {

    const fileInfo = fileInfosTemplate.firstElementChild.cloneNode(true) as HTMLElement

    const filename = fileInfo.querySelector('.comp-fileupload--filename')
    const remove = fileInfo.querySelector('.comp-fileupload--remove')

    const lastIndex = file.name.lastIndexOf(".")
    const name = file.name.substring(0, lastIndex)
    const type = file.name.substring(lastIndex)

    filename.innerHTML = `<span>${name}</span><span>${type}</span><span>(${humanReadableSize(file.size)})</span>`

    if (file.size > maxSize) {
      filename.classList.add("size-error")
    }

    remove.addEventListener("click", () => {

      /*
        fileInput = main file input if multiple=true
        input = sub-input if multiple=true

        if multiple=false fileInput === input
      */

      if (fileInput.multiple) {
        fileInput.title = fileInput.title.replace(`${input.files[0].name}\n`, "")
        if (fileInput.title == "") {
          fileInput.removeAttribute("title")
          fileInput.classList.remove("file-selected")
        }
      } else {
        input.removeAttribute("title")
        input.classList.remove("file-selected")
      }

      input.value = null
      fileInfo.remove()
      checkUploadSize()
      updateMultipleFileCounter()
    })

    fileList.appendChild(fileInfo)

  }

  const onChange = () => {

    if (fileInput.files.length > 0) {

      const files = new DataTransfer()

      for (let i = 0; i < fileInput.files.length; i++) {
        files.items.add(fileInput.files[i])
      }

      fileInput.classList.add("file-selected")

      fileList.innerHTML = ""

      if (fileInput.multiple) {

        let title = ""

        const fileInputs = fileInput.closest(
          ".file-upload-multiple-fieldset"
        ).querySelectorAll(
          'input'
        )

        // clear all inputs, before write new
        Array.from(fileInputs).forEach((input) => {
          input.value = null
        })

        // spit files from main-input to sub-inputs: each file to one input
        // typo3 doesn't support input.multiple=true
        for (let i = 0; i < fileInputs.length && i < files.items.length; i++) {

          const currentFile = files.items[i].getAsFile()

          inputAddFile(fileInputs[i], currentFile)
          title += `${currentFile.name}\n`
          addFilenameWithButton(fileInputs[i], currentFile)
        }

        updateMultipleFileCounter()

        fileInput.title = title

      } else {
        addFilenameWithButton(fileInput, files.items[0].getAsFile())
      }

      checkUploadSize()

    }
  }

  fileInput.addEventListener('change', onChange)

}

register('FileUpload', FileUpload)
